import { Locale } from "../Locale.js";
import { localizePathMap } from "./localizePathMap.js";

export const careersPathMap = localizePathMap({
	[Locale.cs]: "kariera",
	[Locale.en]: "careers",
});
